import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'react-bootstrap';
import Microsoft from "../../images/download.png";
import '../../styles/components/ModulesScreen.scss';
import checkmarkgreen from "../../images/ChecjmarkGreen.svg";
import DraftStatus from "../../images/Draft.svg";
import CheckMarkFilled from "../../images/checkmark-filled.svg";
import CommonStatus from "../../images/common_status.svg";
import WithdrawnStatus from "../../images/withdrawn.svg";
import ExpiredStatus from "../../images/expired status.svg";
import nothumbNail from "../../images/noThumbnail.svg";
import Tooltip from "@mui/material/Tooltip";
import { CircularProgress } from "@mui/material";
const ModuleRulesetsCard = ({ existWith, modulesData,
  ruleSetsData, active, selectDeselectRuleSet, moduleDamName,
  moduleName,
  link,
  mlrStatuses,
  setMlrstatuses,
  parentmodule,
  getModuleDetailsForPreview

}) => {
  const getThumbnail = () => {

    if (link === "Parentcard") {
      return ruleSetsData?.componentUrl || nothumbNail;
    } else if (link === "childCard") {
      return ruleSetsData?.targetModuleComponentThumbnailUrl || nothumbNail;
    } else {
      return nothumbNail
    }
  }

  const statusObj = mlrStatuses?.find(
    (status) => status.targetModuleDamName === ruleSetsData?.targetModuleDamName
  );
  const status = statusObj ? statusObj.targetModuleMlrStatus : "Not Submitted";

  const getStatusIcon = (status) => {
    if (!status) return CommonStatus;
    switch (status.toLowerCase()) {
      case "not submitted":
      case "draft":
        return DraftStatus;
      case "available for use":
        return CheckMarkFilled;
      case "expired":
        return ExpiredStatus;
      case "pending withdrawal":
      case "withdrawn":
        return WithdrawnStatus;
      default:
        return CommonStatus;
    }
  };
  return (
    <div className={active ? " moduleRulesetcardActive" : "moduleRulesetcard"}
      onClick={selectDeselectRuleSet}
      style={{ margin: existWith === "isSelectedModule" ? "15px" : "" }}>

      <div className={getThumbnail() !== nothumbNail ? 'imageContainer' : 'imageContainer imageContainerEmpty'}>
        <img
          src={getThumbnail()}
          // src={
          //  ruleSetsData?.targetModuleComponentThumbnailUrl ? ruleSetsData?.targetModuleComponentThumbnailUrl : nothumbNail  }
          className='img-fluid' alt="thumbnail" />
      </div>
      <div className='contentText1'>
        <div className='moduleNumberRow d-flex'>
          <p className="basic-info">


            {
              parentmodule === "Parent Module" ?

                <Tooltip title={'Available for use'}>
                  <img src={checkmarkgreen} className='img-fluid' />
                </Tooltip> :
                <Tooltip title={status}>
                  <img src={getStatusIcon(status)} className='img-fluid' />
                </Tooltip>}
            <strong className="cm-modulemNum infosec">{ruleSetsData?.[moduleDamName]}</strong>
          </p>
          <button className="btn viewbtn modulesView"
            onClick={(e) => {
              e.stopPropagation();

              getModuleDetailsForPreview(ruleSetsData?.id || ruleSetsData?.targetModuleId);
            }}>VIEW</button>
        </div>

        <p className="basic-info nameSec">
          <span >Name : </span>{" "}
          <Tooltip
            title={ruleSetsData?.[moduleName]}
            placement="top"
          >
            <strong
              className={existWith === "isSelectedModule" ? "truncate2 infosec" : "truncateName infosec"

              }>
              {ruleSetsData?.[moduleName]}</strong></Tooltip>
        </p>
      </div>

    </div>
  );
};

export default ModuleRulesetsCard;
